import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { Utils } from "../../Utils";


export class HUD extends Phaser.Group {

    private chickenCounterLabelShadow: Phaser.Text;
    private chickenCounterLabel: Phaser.Text;
    private scoreLabel: Phaser.Text;
    private scoreLabelShadow: Phaser.Text;
    private timerBoost: number;
    private featherImg: Phaser.Image;
    private featherLabelShadow: Phaser.Text;
    private featherLabel: Phaser.Text;
    private featherContainer: Phaser.Group;

    constructor(game: Phaser.Game) {

        super(game, null, "hud");

        this.timerBoost = 10;

        const chickenCounterLabel_px = GameConstants.SPONSOR === GameConstants.SPONSOR_FUNO ? 180 * GameVars.scaleX : GameConstants.GAME_WIDTH - 5 * GameVars.scaleX ;
        const chickenCounterLabel_py = 30;

        this.chickenCounterLabelShadow = new Phaser.Text(this.game, chickenCounterLabel_px + 1.5, chickenCounterLabel_py + 4, "0/25", { font: "55px RoundsBlack", fill: "#FFA700" });
        this.chickenCounterLabelShadow.anchor.set(1, .5);
        this.chickenCounterLabelShadow.scale.x = GameVars.scaleX;
        this.add(this.chickenCounterLabelShadow);

        this.chickenCounterLabel = new Phaser.Text(this.game, chickenCounterLabel_px, chickenCounterLabel_py, "0/25", { font: "55px RoundsBlack", fill: "#fff8e4" });
        this.chickenCounterLabel.anchor.set(1, .5);
        this.chickenCounterLabel.scale.x = GameVars.scaleX;
        this.add(this.chickenCounterLabel);

        const scoreContainer = new Phaser.Group(this.game);
        scoreContainer.x = GameConstants.GAME_WIDTH / 2;
        scoreContainer.y = 25;
        scoreContainer.scale.x = GameVars.scaleX;
        this.add(scoreContainer);

        const score_px = -5;
        const score_py = 0;

        const scoreShadow = new Phaser.Text(this.game, score_px + 1, score_py + 3, "score:", { font: "38px RoundsBlack", fill: "#FFA700" });
        scoreShadow.anchor.set(1, .5);
        scoreContainer.add(scoreShadow);

        const score = new Phaser.Text(this.game, score_px, score_py, "score:", { font: "38px RoundsBlack", fill: "#fff8e4" });
        score.anchor.set(1, .5);
        scoreContainer.add(score);

        const scoreLabel_px = 5;
        const scoreLabel_py = 0;

        this.scoreLabelShadow = new Phaser.Text(this.game, scoreLabel_px + 1, scoreLabel_py + 3, Utils.formatNumber(GameVars.score), { font: "38px RoundsBlack", fill: "#FFA700" });
        this.scoreLabelShadow.anchor.set(0, .5);
        scoreContainer.add(this.scoreLabelShadow);

        this.scoreLabel = new Phaser.Text(this.game, scoreLabel_px, scoreLabel_py, Utils.formatNumber(GameVars.score), { font: "38px RoundsBlack", fill: "#fff8e4" });
        this.scoreLabel.anchor.set(0, .5);
        scoreContainer.add(this.scoreLabel);

        this.featherContainer = new Phaser.Group(this.game);
        this.featherContainer.x = GameConstants.GAME_WIDTH - 70;
        this.featherContainer.y = 90;
        this.featherContainer.scale.x = GameVars.scaleX;
        this.featherContainer.visible = false;
        this.add(this.featherContainer);

        this.featherImg = new Phaser.Sprite(this.game, 0, 0, "texture_atlas_1", "feather.png");
        this.featherImg.anchor.set(.5);
        this.featherImg.scale.set(.675);
        this.featherContainer.add(this.featherImg);

        const featherLabel_px = 0;
        const featherLabel_py = 48;

        this.featherLabelShadow = new Phaser.Text(this.game, featherLabel_px + .75, featherLabel_py + 2.5, this.timerBoost.toString(), { font: "40px RoundsBlack", fill: "#FFA700" });
        this.featherLabelShadow.anchor.set(.5);
        this.featherContainer.add(this.featherLabelShadow);

        this.featherLabel = new Phaser.Text(this.game, featherLabel_px, featherLabel_py, this.timerBoost.toString(), { font: "40px RoundsBlack", fill: "#fff8e4" });
        this.featherLabel.anchor.set(.5);
        this.featherContainer.add(this.featherLabel);
    }

    public onChickenSaved(x: number, y: number, points: number): void {

        this.updateScore();

        if (x > 720) {
            x = 720;
        }

        if (y < 120) {
            y = 120;
        }

        let pointsText = new Phaser.Text(this.game, x - 20, y - 70, " straight across \n +" + points, { font: "20px RoundsBlack", fill: "#FFFFFF", align: "center" });
        pointsText.anchor.set(.5);
        pointsText.alpha = 0;
        pointsText.scale.x = GameVars.scaleX;
        pointsText.setShadow(1.5, 1.5, "rgba(0,0,0,0.5)", 5);
        this.add(pointsText);

        this.tweenPoints(pointsText);

        this.chickenCounterLabelShadow.text = GameVars.savedChicken.toString() + "/25";
        this.chickenCounterLabel.text = GameVars.savedChicken.toString() + "/25";
    }

    public onChickenHit(x: number, y: number): void {

        this.updateScore();

        let pointsText = new Phaser.Text(this.game, x, y - 70, " chicken combo \n +5 ", { font: "15px RoundsBlack", fill: "#FFFFFF", align: "center" });
        pointsText.anchor.set(.5);
        pointsText.alpha = 0;
        pointsText.scale.x = GameVars.scaleX;
        pointsText.setShadow(1.5, 1.5, "rgba(0,0,0,0.5)", 5);
        this.add(pointsText);

        this.tweenPoints(pointsText);
    }

    public closeCall(x: number, y: number): void {

        this.updateScore();

        let pointsText = new Phaser.Text(this.game, x, y - 70, " close call \n +200 ", { font: "15px RoundsBlack", fill: "#FFFFFF", align: "center" });
        pointsText.anchor.set(.5);
        pointsText.alpha = 0;
        pointsText.scale.x = GameVars.scaleX;
        pointsText.setShadow(1.5, 1.5, "rgba(0,0,0,0.5)", 5);
        this.add(pointsText);

        this.tweenPoints(pointsText);
    }

    public showBootsTimer(x: number, y: number): void {

        this.timerBoost = 10;
        this.featherLabelShadow.text = this.timerBoost + "";
        this.featherLabel.text = this.timerBoost + "";
        this.featherContainer.visible = true;

        const loop = this.game.time.events.loop(Phaser.Timer.SECOND, function (): void {

            this.timerBoost--;

            this.featherLabelShadow.text = this.timerBoost + "";
            this.featherLabel.text = this.timerBoost + "";

            if (this.timerBoost === 0) {
                this.featherContainer.visible = false;
                this.game.time.events.remove(loop);
            }
        }, this);

        this.updateScore();

        let pointsText = new Phaser.Text(this.game, x, y - 70, " speed boost \n +150 ", { font: "15px RoundsBlack", fill: "#FFFFFF", align: "center" });
        pointsText.anchor.set(.5);
        pointsText.alpha = 0;
        pointsText.scale.x = GameVars.scaleX;
        pointsText.setShadow(1.5, 1.5, "rgba(0,0,0,0.5)", 5);
        this.add(pointsText);

        this.tweenPoints(pointsText);
    }

    private tweenPoints(pointsText: Phaser.Text): void {
        this.game.add.tween(pointsText)
            .to({ y: pointsText.y - 20, alpha: 1 }, 1000, Phaser.Easing.Linear.None, true)
            .onComplete.add(function (): void {
                this.game.add.tween(pointsText)
                    .to({ y: pointsText.y - 20, alpha: 0 }, 1000, Phaser.Easing.Cubic.Out, true)
                    .onComplete.add(function (): void {
                        this.remove(pointsText);
                    }, this);
            }, this);
    }

    private updateScore(): void {

        this.scoreLabelShadow.text = Utils.formatNumber(GameVars.score);
        this.scoreLabel.text = Utils.formatNumber(GameVars.score);
    }
}
